export default __webpack_public_path__ + "media/50fa5f37c8c82b861875af7d9b49b597e8bcd4daf3ed4e85c1c63b03a60663f5.svg";